import { jaccardWeight } from './WeightFunctions';


function computeWeightedAgreement(codeCount, weightFn) {
    const categories = Object.keys(codeCount);
    let weightedSum = 0;
    let totalCoders = 0;
    for (const a of categories) {
        totalCoders += codeCount[a];
        for (const b of categories) {
            weightedSum += weightFn(a, b) * codeCount[a] * codeCount[b];
        }
    }
    // Subtract self-pairings (a coder compared to themselves always has weight 1)
    return { agreement: weightedSum - totalCoders, totalCoders };
}

function computeRatios(objArray) {
    return objArray.map(obj => {
        return {
            ratio: obj.size * obj.agreement / (obj.totalCoders - 1),
            sum: obj.totalCoders * obj.size
        };
    });
}

function computeResult(objArray) {
    let sumRatios = 0;
    let sumSums = 0;

    objArray.forEach(obj => {
        sumRatios += obj.ratio;
        sumSums += obj.sum;
    });

    const inverseSumSums = 1 / sumSums;
    const ratio = sumRatios * inverseSumSums;

    return (1 - inverseSumSums) * ratio + inverseSumSums;
}

function calculatePA(overlappingExcerpts, weightFn = jaccardWeight) {
    const codeSize = overlappingExcerpts.map((excerpt) => {
        const { agreement, totalCoders } = computeWeightedAgreement(excerpt.code_count, weightFn);

        return {
            size: excerpt.end - excerpt.start,
            agreement,
            totalCoders,
        }
    })

    const ratios = computeRatios(codeSize);
    const pa = computeResult(ratios);
    return pa;
}

export default calculatePA;
